import { gql } from 'graphql-request'

export const CancelOfferGql = gql`
  mutation cancelOffer($offerId: UUID!) {
    cancelOffer(offerId: $offerId) {
      errorMessage
      success
    }
  }
`
